export const searchSelectStyle = {
  option: (provided: any, state: any) => ({
    ...provided,
    borderBottom: '.1rem solid #d8d8d8',
    padding: '1.8rem 1.5rem 1.5rem',
    fontSize: '1.4rem',
    fontFamily: 'LatoItalic, Arial, sans-serif',
    fontWeight: state.isSelected ? 700 : 400,
    backgroundColor: state.isSelected ? '#f3f6fa' : '#fff',
    color: '#212529',
    cursor: 'pointer',
    transition: 'all .3s ease',
    '&:hover': {
      backgroundColor: '#f3f6fa',
    },
    '&:last-child': {
      borderBottom: 'none',
    },
  }),
  control: (provided: any) => ({
    ...provided,
    border: '.1rem solid #d8d8d8',
    borderRadius: 0,
    height: '52px',
    boxShadow: 'none',
    cursor: 'pointer',
    '&:hover': {
      borderColor: '#d8d8d8',
    },
  }),
  indicatorSeparator: () => ({
    display: 'none',
  }),
  valueContainer: () => ({
    maxWidth: 'calc(100% - 5rem)',
    overflow: 'hidden',
  }),
  input: () => ({
    paddingLeft: '1.5rem',
    input: {
      fontSize: '1.4rem',
      fontFamily: 'LatoItalic, Arial, sans-serif',
      fontWeight: 600,
    },
  }),
  dropdownIndicator: (provided: any) => ({
    ...provided,
    color: '#420C23',
    '&:hover': {
      color: '#420C23',
    },
  }),
  menu: (provided: any) => ({
    ...provided,
    margin: 0,
    border: '0.1rem solid #d8d8d8',
    boxShadow: 'none',
    borderRadius: 0,
    borderTop: 'none',
  }),
  menuList: (provided: any) => ({
    ...provided,
    paddingTop: 0,
  }),
  singleValue: (provided: any) => ({
    ...provided,
    color: '#212529',
    fontSize: '1.4rem',
    fontFamily: 'LatoItalic, Arial, sans-serif',
    fontWeight: 600,
    maxWidth: 'calc(100% - 50px)',
    paddingRight: '.2rem',
    paddingLeft: '1.5rem',
  }),
  loadingIndicator: () => ({
    display: 'none',
  }),
}
